import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { refreshOutline, closeOutline } from 'ionicons/icons';

interface UpdateButtonProps {
    onUpdate: () => void;
    isVisible: boolean;
    message?: string;
}

const UpdateAvailableButton: React.FC<UpdateButtonProps> = ({
    onUpdate,
    isVisible,
    message = 'A new version is available!',
}) => {
    const [dismissed, setDismissed] = useState(false);

    if (!isVisible || dismissed) {
        return null;
    }

    return (
        <div style={styles.overlay}>
            <div style={styles.toast}>
                <IonIcon icon={refreshOutline} style={styles.icon} />
                <div style={styles.textContainer}>
                    <strong style={styles.title}>{message}</strong>
                    <span style={styles.subtitle}>Refresh to get the latest features.</span>
                </div>
                <div style={styles.actions}>
                    <button onClick={onUpdate} style={styles.refreshBtn}>
                        Refresh now
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    overlay: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        padding: '12px',
        pointerEvents: 'none',
    },
    toast: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        maxWidth: '520px',
        width: '100%',
        padding: '12px 16px',
        background: 'var(--ion-color-primary, #3880ff)',
        color: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
        pointerEvents: 'auto',
        animation: 'slideUp 0.3s ease-out',
    },
    icon: {
        flexShrink: 0,
        fontSize: '28px',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
    },
    title: {
        fontSize: '14px',
        lineHeight: '1.3',
    },
    subtitle: {
        fontSize: '12px',
        opacity: 0.85,
        lineHeight: '1.3',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexShrink: 0,
    },
    refreshBtn: {
        padding: '6px 14px',
        borderRadius: '8px',
        border: 'none',
        background: '#fff',
        color: 'var(--ion-color-primary, #3880ff)',
        fontWeight: 600,
        fontSize: '13px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    laterBtn: {
        background: 'transparent',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        opacity: 0.8,
    },
};

export default UpdateAvailableButton;
